import React from 'react';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { PET_TYPES, CLUB_TYPES } from '../../data/createClubData';

export default function Step2PetTypes({ formData, setFormData }) {
  return (
          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle>Pet Types</CardTitle>
                <CardDescription>What pets will your club focus on? Select all that apply.</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {PET_TYPES.map(pet => {
                    const Icon = pet.icon;
                    const isSelected = formData.pet_types.includes(pet.id);
                    return (
                      <button
                        key={pet.id}
                        type="button"
                        onClick={() => togglePetType(pet.id)}
                        className={`flex flex-col items-center gap-2 p-4 rounded-lg border text-center transition-all ${
                          isSelected 
                            ? 'bg-primary/10 border-primary ring-2 ring-primary/20' 
                            : 'bg-background hover:bg-muted border-border'
                        }`}
                        data-testid={`pet-type-${pet.id}`}
                      >
                        <Icon className={`w-8 h-8 ${isSelected ? 'text-primary' : 'text-muted-foreground'}`} />
                        <span className="font-medium text-sm">{pet.label}</span>
                        <span className="text-xs text-muted-foreground">{pet.description}</span>
                      </button>
                    );
                  })}
                </div>
                
                {/* Other pet type fill-in */}
                {formData.pet_types.includes('other') && (
                  <div className="mt-4 p-4 bg-muted/50 rounded-lg">
                    <Label htmlFor="other-pet-type">Specify your pet type *</Label>
                    <Input
                      id="other-pet-type"
                      value={formData.other_pet_type}
                      onChange={(e) => setFormData(prev => ({ ...prev, other_pet_type: e.target.value }))}
                      placeholder="e.g., Ferrets, Sugar Gliders, Alpacas..."
                      className="mt-2"
                      data-testid="other-pet-type-input"
                    />
                  </div>
                )}
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Club Type</CardTitle>
                <CardDescription>What type of organization is this?</CardDescription>
              </CardHeader>
              <CardContent>
                <RadioGroup
                  value={formData.club_type}
                  onValueChange={(value) => setFormData(prev => ({ ...prev, club_type: value }))}
                  className="space-y-3"
                >
                  {CLUB_TYPES.map(type => (
                    <div 
                      key={type.id}
                      className={`flex items-center justify-between p-4 rounded-lg border cursor-pointer transition-all ${
                        formData.club_type === type.id ? 'bg-primary/10 border-primary' : 'hover:bg-muted'
                      }`}
                      onClick={() => setFormData(prev => ({ ...prev, club_type: type.id }))}
                    >
                      <div className="flex items-center gap-3">
                        <RadioGroupItem value={type.id} id={type.id} />
                        <div>
                          <Label htmlFor={type.id} className="font-medium cursor-pointer">{type.label}</Label>
                          <p className="text-sm text-muted-foreground">{type.description}</p>
                        </div>
                      </div>
                      <Badge variant={type.fee === 'Free' ? 'secondary' : 'outline'}>{type.fee}</Badge>
                    </div>
                  ))}
                </RadioGroup>
              </CardContent>
            </Card>
          </div>
  );
}
